import { type FC, type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Icon } from '@/ui';

import type { User } from '@/types';

import { useAppDispatch } from '@/store/hooks';
import { setChatId } from '@/store/slices/appSlice';


const Footer: FC<User> = ({ id, cometChatId }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onClickView = (event: MouseEvent) => {
    event.stopPropagation();
    navigate(`/coach/members/${id}`);
  };

  const onChatView = (event: MouseEvent) => {
    event.stopPropagation();
    dispatch(setChatId(cometChatId));
  };

  return (
    <div className="mt-auto flex gap-1 px-4 pt-4">
      <Button className="w-full" variant="outlined" onClick={onClickView}>
        View
      </Button>
      <Button
        className="min-w-min px-2.5"
        variant="contained"
        onClick={onChatView}
      >
        <Icon>chat_bubble</Icon>
      </Button>
    </div>
  );
};

export default Footer;
